import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import Breadcrumbs from 'shared/lib/components/controls/breadcrumbs/breadcrumbs';
import { useNavigate } from 'react-router-dom';
import BreadcrumbsItem from 'shared/lib/components/controls/breadcrumbs/breadcrumbsItem';
import PageWrapper from 'shared/lib/components/containers/pageWrapper';
import { Box, Typography } from '@mui/material';
import PagePaddingWrapper from 'shared/lib/components/containers/pagePaddingWrapper';
import { useTranslation } from 'react-i18next';
import { UiContext } from 'shared/lib/contexts/uiContext';
import ProfileCard from './profileCard';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import ProfileContent from 'pages/profilePage/content/profileContent';
import ProfileEdit from 'pages/profilePage/profileEdit/profileEdit';

export type ProfilePageActiveElement = 'profileCard' | 'profileEdit';

export default observer(function ProfilePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    mobxStore: { authStore },
  } = useContext(MobxContext);
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const [activeElement, setActiveElement] =
    useState<ProfilePageActiveElement>('profileCard');

  const user = authStore.user;

  const activeElementComponent = useMemo(() => {
    if (!user) {
      return <Typography>{'Пользователь не найден'}</Typography>;
    } else if (activeElement === 'profileCard') {
      return (
        <ProfileCard
          user={user}
          handleGoToProfileEdit={() => {
            setActiveElement('profileEdit');
          }}
        ></ProfileCard>
      );
    } else if (activeElement === 'profileEdit') {
      return (
        <ProfileEdit
          user={user}
          handleGoToProfileCard={() => setActiveElement('profileCard')}
        ></ProfileEdit>
      );
    }
  }, [activeElement, t, user]);

  return (
    <>
      <PageWrapper>
        <PagePaddingWrapper
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <PageInnerContainer sx={{ pt: 0 }}>
            <Breadcrumbs>
              <BreadcrumbsItem
                onClick={() => {
                  navigate('/', { replace: false });
                }}
                title={t('breadcrumbs.main')}
              >
                {t('breadcrumbs.main')}
              </BreadcrumbsItem>
              <BreadcrumbsItem title={t('breadcrumbs.profile')}>
                {t('breadcrumbs.profile')}
              </BreadcrumbsItem>
            </Breadcrumbs>

            <Box>
              <Box sx={{ mb: sp.s70 }}>
                <Typography variant="f36b">{t('common.profile')}</Typography>
              </Box>
              {activeElementComponent}
            </Box>

            {activeElement === 'profileCard' && (
              <ProfileContent></ProfileContent>
            )}
          </PageInnerContainer>
        </PagePaddingWrapper>
      </PageWrapper>
    </>
  );
});
